/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import PersonalHeader from '../../PersonalDetails/components/header';
// import PersonalDetailsContent from '../../PersonalDetails/components/content';
import CreateCustomer from '../../Customers/componenets/create';
import Filter from '../../Filter';
import fields from '../fields';
import useFetchData from '../../../hooks/useFetchData';
import usePostData from '../../../hooks/usePostData';
import useSort from '../../../hooks/useSort';
// import { ReactComponent as Editicon } from '../../../assets/images/edit.svg';
// import { ReactComponent as SmsIcon } from '../../../assets/images/sms.svg';
// import { ReactComponent as EyeIcon } from '../../../assets/images/eye.svg';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { tableHeadersClients, columnsClients } from '../../Customers/utils';
import SnackBar from 'components/SnackBar';
import globalTranslating from '../../../translate.json';
import OrgTranslate from '../translate.json';
import '../style.scss';
import TablePagination from 'components/TablePaginationComponent';
import InviteCustomers from './InviteCustomers';

const OrganizationPage = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...OrgTranslate };
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [currentOrg, setCurrentOrg] = useState();
  const [filteredOrgCustomers, setFilteredOrgCustomers] = useState([]);
  const { postData, res, payload, error } = usePostData();
  const { showFilters, toggle } = useSort();
  const { id } = useParams();
  const [errFun, setErrFun] = useState();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState();
  const { data: organizationData } = useFetchData('organization', id);
  // Collapse state for sections
  const [showInvitedSection, setShowInvitedSection] = useState(false);
  const [showRelatedSection, setShowRelatedSection] = useState(false);
  const [showInvitationsSection, setShowInvitationsSection] = useState(false);
  const {
    postData: updateCustomerStatus,
    res: updateRes,
    error: updateError
  } = usePostData();

  useEffect(() => {
    setFilteredOrgCustomers(organizationData?.org_clients);
    let orgDetails = { ...organizationData?.org_details };
    let addressData = orgDetails?.address;
    if (addressData) {
      addressData = addressData.split(',');
      orgDetails.city = addressData[0];
      orgDetails.street = addressData[1];
      orgDetails.buildingNumber = addressData[2];
      orgDetails.apartmentNumber = addressData[3];
    }
    setCurrentOrg(orgDetails);
  }, [organizationData]);

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    } else if (res && res.affected === 1 && payload) {
      let addressData = payload.address;
      if (addressData) {
        addressData = addressData.split(',');
        payload.city = addressData[0];
        payload.street = addressData[1];
        payload.buildingNumber = addressData[2];
        payload.apartmentNumber = addressData[3];
      }
      setMessageSnackbar('ארגון עודכן');
      setShowSnakbar(true);
      setCurrentOrg(payload);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    console.log('update org data  :', data);
    let deepData = { ...data };
    deepData.address = `${deepData.city},${deepData.street},${deepData.buildingNumber},${deepData.apartmentNumber},`;
    delete deepData.city;
    delete deepData.street;
    delete deepData.buildingNumber;
    delete deepData.apartmentNumber;
    postData(`organization/${id}`, deepData, 'patch');
  };

  const onFilter = (filteredData) => {
    setFilteredOrgCustomers(filteredData);
  };

  const onResetFilters = () => {
    setFilteredOrgCustomers(organizationData?.org_clients);
  };

  const handleAddCustomer = (newCustomer) => {
    if (newCustomer) {
      let newList = [...filteredOrgCustomers];
      newList.push(newCustomer);
      setFilteredOrgCustomers(newList);
      setMessageSnackbar('לקוח נוסף לארגון');
      setShowSnakbar(true);
    }
    setShowAddCustomer(!showAddCustomer);
  };

  // Handle invite success/error callbacks
  const handleInviteSuccess = (message) => {
    setMessageSnackbar(message);
    setShowSnakbar(true);
  };

  const handleInviteError = (message) => {
    setMessageSnackbar(message);
    setShowSnakbar(true);
  };
  // Handle customer status toggle
  const handleToggleCustomerStatus = (customerId, currentStatus) => {
    const newStatus = !currentStatus;

    // Update the local state immediately (optimistic update)
    setFilteredOrgCustomers((prevCustomers) =>
      prevCustomers.map((customer) => {
        if (customer.id === customerId) {
          return { ...customer, isActive: newStatus };
        }
        return customer;
      })
    );

    updateCustomerStatus(
      `client/${customerId}`,
      { isActive: newStatus },
      'patch'
    );
  };

  // Handle update customer status API response
  useEffect(() => {
    if (updateRes && updateRes.affected > 0) {
      setMessageSnackbar('סטטוס הלקוח עודכן בהצלחה');
      setShowSnakbar(true);
    }
    if (updateError) {
      setMessageSnackbar('שגיאה בעדכון סטטוס הלקוח');
      setShowSnakbar(true);
    }
  }, [updateRes, updateError]);

  const actions = [
    // { icon: Editicon, name: 'edit', txt: translating.edit, 'handleClickAction': handleClickAction },
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['full_name', 'email']
    }
  ];

  // Custom columns for organization customers table with status toggle
  const orgCustomersColumns = columnsClients
    .filter((c) => c.value !== 'organization')
    .map((column) => {
      if (column.value === 'isActive') {
        return {
          ...column,
          format: 'toggleSwitch',
          handleAction: handleToggleCustomerStatus
        };
      }
      return column;
    });

  // Custom headers for organization customers table (same as original, just without organization)
  const orgCustomersHeaders = tableHeadersClients.filter(
    (h) => h !== translating.orgRelated
  );

  const actionsOrgsList = [
    {
      icon: SortIcon,
      txt: 'עריכה',
      handleClickAction: () => toggle(!showFilters)
    }
  ];

  // Actions with collapse toggle for sections

  const actionsRelatedList = [
    {
      txt: showRelatedSection ? '-' : '+',
      handleClick: () => setShowRelatedSection((prev) => !prev)
    },
    ...actionsOrgsList
  ];

  const actionsInvitationsList = [
    {
      txt: showInvitationsSection ? '-' : '+',
      handleClick: () => setShowInvitationsSection((prev) => !prev)
    }
  ];

  return (
    <div className="organization-page">
      {currentOrg?.id && (
        <>
          <SectionHeader
            title={translating.organization}
            newItem={{
              handleClick: () => handleAddCustomer(),
              txt: translating.craeteCustomerToOrg
            }}
          ></SectionHeader>
          <div className="personal-details">
            <PersonalHeader
              title={translating.orgDetailsHeader}
              actions={actions}
            ></PersonalHeader>
            <FormGroup
              fields={fields()}
              data={currentOrg}
              onSubmit={onSubmit}
            ></FormGroup>
          </div>
          {showAddCustomer && (
            <CreateCustomer
              organizationId={currentOrg?.id}
              handleAddCustomerToOrg={handleAddCustomer}
            ></CreateCustomer>
          )}
          {/* Invite Customers Component */}
          <InviteCustomers
            organizationId={id}
            onInviteSuccess={() => handleInviteSuccess('ההזמנה נשלחה בהצלחה')}
            onError={() => handleInviteError('שגיאה בשליחת הזמנות')}
          />
          {/* Organization Invitations Section */}
          {organizationData?.org_invitations?.length ? (
            <div className="customers-org-list">
              <SectionHeader
                title={`הזמנות שנשלחו (${organizationData.org_invitations.length})`}
                actions={actionsInvitationsList}
              ></SectionHeader>
              {showInvitationsSection && (
                <TablePagination
                  headers={['מייל', 'תאריך הזמנה', 'סטטוס', 'פרטים נוספים']}
                  columns={[
                    { value: 'email', sort: true },
                    { value: 'createdAt', format: 'date', sort: true },
                    { value: 'status', sort: true },
                    {
                      value: 'details',
                      format: 'detailsDialog',
                      sort: false,
                      dialogTitle: 'פרטים נוספים'
                    }
                  ]}
                  rows={organizationData.org_invitations}
                  pagination={true}
                ></TablePagination>
              )}
            </div>
          ) : (
            ''
          )}
          {organizationData?.org_clients?.length ? (
            <div className="customers-org-list">
              <SectionHeader
                title={`${translating.relatedClients}`}
                actions={actionsRelatedList}
              ></SectionHeader>
              {showRelatedSection && (
                <>
                  {showFilters && (
                    <Filter
                      fields={sortFields}
                      data={filteredOrgCustomers}
                      handleFilter={onFilter}
                      handleReset={onResetFilters}
                    ></Filter>
                  )}
                  {filteredOrgCustomers && (
                    <TablePagination
                      headers={orgCustomersHeaders}
                      columns={orgCustomersColumns}
                      rows={filteredOrgCustomers}
                      pagination={true}
                      handleRowClick={(id, e, row) =>
                        navigate(`/clients/${row.client_uuid}`)
                      }
                    ></TablePagination>
                  )}
                </>
              )}
            </div>
          ) : (
            ''
          )}
        </>
      )}
      {showSnackbar && (
        <SnackBar
          msg={messageSnackbar}
          handleClose={() => {
            setShowSnakbar(false);
            setMessageSnackbar(null);
          }}
        ></SnackBar>
      )}
    </div>
  );
};

export default OrganizationPage;
